import { FileTypeConst } from '@/common/types/Files.type';
import { deleteAccessoryQueryFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/deleteSubstitutionPart/deleteAccessoryQueryFunction';
import { deleteSubstitutionPartQueryFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/deleteSubstitutionPart/deleteSubstitutionPartQueryFunction';
import { DeleteSubstitutionPartParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/deleteSubstitutionPart/deleteSubstitutionPartQueryOption.type';
import { useMutation } from '@tanstack/react-query';

export const useDeleteSubstitutionPartQuery = ({
  type,
}: {
  type?: FileTypeConst;
}) => {
  const mutationFn = (params: DeleteSubstitutionPartParamsType) => {
    if (type && type === 'initial') {
      return deleteAccessoryQueryFunction(params);
    }
    return deleteSubstitutionPartQueryFunction(params);
  };

  return useMutation({
    mutationFn: (params: DeleteSubstitutionPartParamsType) =>
      mutationFn(params),
    mutationKey: ['deleteSubstitutionPartQuery'],
  });
};
